import OrderTracker from "@iewccouk/Components/OrderTracker";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const loadingWrapperCss = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 160px;
    gap: 16px;
`;

const enum fields {
    heading = "heading",
    description = "description",
    statusSequence = "statusSequence",
    allProductsInLastStepLabel = "allProductsInLastStepLabel",
}

export interface StatusSequenceModel {
    fields: {
        labelSingular: string;
        labelPlural: string;
    };
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.description]: string;
        [fields.statusSequence]: StatusSequenceModel[];
        [fields.allProductsInLastStepLabel]: string;
    };
}


type Props = OwnProps;

const OrderDetailsOrderTracker: FC<Props> = ({ fields }) => {
    const order = useContext(OrderStateContext) as any;
    const tracker = order?.value?.orderTracker;

    if (order?.isLoading) {
        return (
            <StyledWrapper css={loadingWrapperCss} data-test-selector="orderDetailsOrderTracker_loading">
                <LoadingSpinner />
            </StyledWrapper>
        );
    }

    return <OrderTracker tracker={tracker} fields={fields} />;
};

const widgetModule: WidgetModule = {
    component: connect(null)(OrderDetailsOrderTracker),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        displayName: "Order tracker",
        group: "Order Details",
        fieldDefinitions: [
            {
                name: fields.heading,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Order Status",
                isRequired: false,
            },
            {
                name: fields.allProductsInLastStepLabel,
                displayName: "All products in last step label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "All lines shipped",
                isRequired: true,
            },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "RichTextField",
                defaultValue: "Your order may be shipped in multiple deliveries. Check statuses below.",
                fieldType: "Translatable",
                isRequired: false,
            },
            {
                name: fields.statusSequence,
                editorTemplate: "ListField",
                displayName: "Status Sequence",
                getDisplay: (item: HasFields) => item.fields.labelPlural,
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "labelSingular",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "Singular Label",
                        isRequired: true,
                    },
                    {
                        name: "labelPlural",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "Plural Label",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
